export const WELCOME_PAGE_VIEW_TK = "WELCOME_PAGE_VIEW_TK";

export const WELCOME_PAGE_VIEW_TRANSLATION_NAMESPACE = "welcome-page";

export const VITE_SPECIAL_DISPLAY_WELCOME_PAGE_ORGA_LIST = import.meta.env
    .VITE_SPECIAL_DISPLAY_WELCOME_PAGE_ORGA_LIST;
export const VITE_WELCOME_PAGE_FORBIDDEN_ORGA_LIST = import.meta.env
    .VITE_WELCOME_PAGE_FORBIDDEN_ORGA_LIST;
